import {useProducts} from '@salesforce/commerce-sdk-react'

/**
 * Custom hook for cart products data and calculations
 * @param {Object} basket - The shopping basket object
 * @returns {Object} - Products data and total items count
 */
export const useCartProducts = (basket) => {
    // Calculate total items count
    const totalItems = basket?.productItems?.reduce((acc, item) => acc + item.quantity, 0) || 0

    // Get product IDs for API call
    const productIds = basket?.productItems?.map(({productId}) => productId).join(',') ?? ''

    // Fetch products data
    const {data: products} = useProducts(
        {
            parameters: {
                ids: productIds,
                allImages: true
            }
        },
        {
            enabled: Boolean(productIds),
            select: (result) => {
                // Convert array into key/value object with key is the product id
                return result?.data?.reduce((result, item) => {
                    const key = item.id
                    result[key] = item
                    return result
                }, {})
            }
        }
    )

    return {
        totalItems,
        products
    }
}
